import Base from 'app/views/base';

import { trimMoney } from 'utils/strings';
import tmpl from 'templates/rate_list_item';

export default Base.extend({
  compiledTemplate: tmpl,

  events: {},

  context() {
    return {
      service: this.model.get('service'),
      carrier: this.model.get('carrier'),
      rate: trimMoney(this.model.get('rate'), 'USD'),
    };
  },
});



// WEBPACK FOOTER //
// ./app/views/rate_list_item_view.js